import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar/Navbar';
import { Footer } from './components/Footer/Footer';
import { ScrollToTop } from './components/ScrollToTop/ScrollToTop';
import { HomePage } from './pages/HomePage/HomePage';
import { AboutPage } from './pages/AboutPage/AboutPage';
import { ServicesPage } from './pages/ServicesPage/ServicesPage';
import { FreightPage } from './pages/FreightPage/FreightPage';
import { WarehousePage } from './pages/WarehousePage/WarehousePage';
import { LastMilePage } from './pages/LastMilePage/LastMilePage';
import { CustomLogisticsPage } from './pages/CustomLogisticsPage/CustomLogisticsPage';
import { CoveragePage } from './pages/CoveragePage/CoveragePage';
import { QuotePage } from './pages/QuotePage/QuotePage';
import { CareersPage } from './pages/CareersPage/CareersPage';
import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage';
import { ContactPage as ContactRoutePage } from './pages/ContactPage/ContactPage';

function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/freight-transportation" element={<FreightPage />} />
        <Route path="/services/warehouse-storage" element={<WarehousePage />} />
        <Route path="/services/last-mile-delivery" element={<LastMilePage />} />
        <Route path="/services/custom-logistics" element={<CustomLogisticsPage />} />
        <Route path="/coverage" element={<CoveragePage />} />
        <Route path="/quote" element={<QuotePage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactRoutePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;

